import Cookies from 'js-cookie'

// Function to set cookies for Sitecore header functions
// cp_login to control login status
// refresh_token for logout functionality
const CP_LOGIN = 'cp_login'
const REFRESH_TOKEN = 'refresh_token'
export function setSitecoreCookies(refresh_token: string | undefined): void {
  setSecret(CP_LOGIN, String(true))
  if (refresh_token !== undefined) {
    setSecret(REFRESH_TOKEN, String(refresh_token))
  }
  // we set the cp_login cookie after the page load.
  // That means that the sitecore header does not automatically update
  // We enforce a page reload here to update the sitecore header status
  globalThis.dispatchEvent(
    new CustomEvent('cp_login_successful', {
      bubbles: true,
      detail: {}
    })
  )
}

export function setSecret(name: string, value: string): void {
  Cookies.set(name, value, { sameSite: 'lax', domain: extractTopDomainFromHostname() })
}

export function extractTopDomainFromHostname(): string {
  const hostnameParts = globalThis.location.hostname.split('.')

  if (hostnameParts.length < 3) {
    return globalThis.location.hostname
  } else {
    return hostnameParts.at(-2) + '.' + hostnameParts.at(-1)
  }
}
